import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportHistoryCheckAwtgRanBranches } from '@api/hitoryCheck';

import { TAwtgRanExportBranchesDTO } from '@interfaces/cmModule/dto/historyCheckDTO';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { HC_AWTG_RAN_BRANCHES_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateExportHcAwtgRanBranches = () => {
	const dispatch = useAppDispatch();

	const { mutate: exportBranches } = useMutation<TAwtgRanExportBranchesDTO>({
		mutationKey: [HC_AWTG_RAN_BRANCHES_EXPORT],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		mutationFn: exportHistoryCheckAwtgRanBranches,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportConfigurationComparisonSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return { exportBranches };
};
